import { BlockStack, Box, Button, Card, InlineGrid, InlineStack, Text } from '@shopify/polaris';
import IfCondition from 'components/shared/If-condition';
import ResizeableSekeletonText from 'components/shared/skeletons/resizeable-skeleton-text/ResizeableSekeletonText';
import useOrdersDashboard from 'features/orders/hooks/useOrdersDashboard';
import { useMemo } from 'react';
//import useOrdersDashboard from 'features/orders/hooks/useOrdersDashboard';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { showOrderCount } from 'utils/dashboardUtils';

const OrderOverview = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const unfulfilledOrders = useOrdersDashboard('unfulfilled');
    const fulfilledOrders = useOrdersDashboard('fulfilled');

    const unfulfilledOrdersCount = useMemo(() => showOrderCount(unfulfilledOrders.meta), [unfulfilledOrders.meta]);
    const fulfilledOrdersCount = useMemo(() => showOrderCount(fulfilledOrders.meta), [fulfilledOrders.meta]);

    return (
        <Card>
            <BlockStack gap={'300'}>
                <InlineStack align="space-between" blockAlign="center">
                    <BlockStack gap={'100'}>
                        <Text as="p" variant="headingSm">
                            {t('DASHBOARD.ORDER_OVERVIEW.TITLE')}
                        </Text>
                        <Text as="p" variant="bodyMd" tone="subdued">
                            {t('DASHBOARD.ORDER_OVERVIEW.DESCRIPTION')}
                        </Text>
                    </BlockStack>
                    <Button onClick={() => navigate('/orders')} variant="primary">
                        {t('DASHBOARD.ORDER_OVERVIEW.VIEW_ORDERS')}
                    </Button>
                </InlineStack>

                <InlineGrid columns={2}>
                    <Box borderInlineEndWidth="025" borderColor="border-disabled" paddingBlock={'200'}>
                        <BlockStack gap={'100'}>
                            <Text as="p" variant="bodyMd" fontWeight="medium">
                                {t('DASHBOARD.ORDER_OVERVIEW.ORDERS_FULFILL')}
                            </Text>
                            <IfCondition condition={unfulfilledOrders.loading}>
                                <ResizeableSekeletonText
                                    width="100px"
                                    height="24px"
                                    color="bg-fill-tertiary"
                                ></ResizeableSekeletonText>
                            </IfCondition>
                            <IfCondition condition={!unfulfilledOrders.loading}>
                                <Text as="p" variant="headingLg">
                                    {unfulfilledOrdersCount}
                                </Text>
                            </IfCondition>
                        </BlockStack>
                    </Box>

                    <Box paddingInlineStart="600" paddingBlock={'200'}>
                        <BlockStack gap={'100'}>
                            <Text as="p" variant="bodyMd" fontWeight="medium">
                                {t('DASHBOARD.ORDER_OVERVIEW.TOTAL_FULFILLED')}
                            </Text>
                            <IfCondition condition={fulfilledOrders.loading}>
                                <ResizeableSekeletonText
                                    width="100px"
                                    height="24px"
                                    color="bg-fill-tertiary"
                                ></ResizeableSekeletonText>
                            </IfCondition>
                            <IfCondition condition={!fulfilledOrders.loading}>
                                <Text as="p" variant="headingLg">
                                    {fulfilledOrdersCount}
                                </Text>
                            </IfCondition>
                        </BlockStack>
                    </Box>
                </InlineGrid>
            </BlockStack>
        </Card>
    );
};

export default OrderOverview;
